const HTML_ESCAPES = new Map([
  ['&', '&amp;'], ['<', '&lt;'], ['>', '&gt;'], ['"', '&quot;'], ["'", '&#39;'],
]);

// autocomplete.js renders templates.suggestion output as HTML, so values must
// be escaped before they reach it.
export const escapeAutocompleteHtml = (value) => String(value)
  .replace(/[&<>"']/g, (char) => HTML_ESCAPES.get(char));
